export default "__VITE_ASSET__BSkf5zOU__"